export function joinNewLinesListsElements(htmlString: string) {
	const parser = new DOMParser();
	const doc = parser.parseFromString(htmlString, "text/html");

	const ul = doc.querySelector("ul");
	if (!ul) return htmlString;

	const newLis = [];
	const lis = Array.from(ul.querySelectorAll("li"));

	// Function to clean text content (trim whitespace)
	const cleanText = (text: string | null) => (text && text.trim()) || ""; // Safe fallback for null

	// Function to check if the next li should merge based on lowercase start
	const shouldMerge = (text: string) =>
		text.charAt(0) === text.charAt(0).toLowerCase() && text.charAt(0) !== "";

	// Process the list items
	for (let i = 0; i < lis.length; i++) {
		let currentText = cleanText(lis[i] && lis[i].textContent); // Check for null explicitly
		let merged = false;

		// Try merging with the next li if it starts with lowercase
		while (i + 1 < lis.length) {
			const nextText = cleanText(lis[i + 1] && lis[i + 1].textContent); // Check for null explicitly

			if (shouldMerge(nextText)) {
				currentText += " " + nextText; // Merge the text
				i++; // Skip the merged li
				merged = true;
			} else {
				break;
			}
		}

		// Only push to newLis if currentText is not empty
		if (currentText) {
			newLis.push(`<li>${currentText}</li>`);
		}
	}

	return `<ul>${newLis.join("")}</ul>`;
}
